<template>
  <v-dialog v-model="dialog" max-width="400px" @close="myDialogClose">
    <template v-slot:activator="{ on, attrs }">
      <span>
        <!-- <v-btn
          text
          v-bind="attrs"
          v-on="on"
          @click="initJoin = true"
        >
          Join
        </v-btn>
        <span>|</span> -->
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
          dark
          @click="initJoin = false"
        >
          Login
        </v-btn>
      </span>
    </template>
    <SignOnForm :initJoin="initJoin" />
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import SignOnForm from './SignOnForm.vue'

export default Vue.extend({
  name: 'SignOn',

  components: {
    SignOnForm
  },

  data: () => ({
    dialog: false,
    initJoin: true
  }),

  methods: {
    myDialogClose () {
      this.dialog = false
    }
  }
})
</script>
